import * as React from 'react';
import { Icon, LabelButton, ModalContainer } from '@teamsnap/snap-ui';
import { FormResult } from './types';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  selectedFormResults?: FormResult[];
};

const DeleteFormResultModal = ({
  isOpen,
  onClose,
  onSubmit,
  selectedFormResults,
}: Props) => {
  const inProcessRegistrations = selectedFormResults?.filter(
    (result) => result.status === 'In Progress' || result.status === 'In Cart'
  );

  const headerText = `${inProcessRegistrations.length} in-process registrant${
    inProcessRegistrations.length > 1 || inProcessRegistrations.length === 0
      ? 's'
      : ''
  } will be deleted`;

  const bodyText =
    'All selected registrations with the status \'In Progress\' or \'In Cart\' will be deleted.';

  const warningText =
    'Canceled or completed registrations will not be deleted if selected.';

  const displayWarning =
    selectedFormResults?.length !== inProcessRegistrations.length;

  return (
    <div
      data-testid="DeleteFormResultModal--container"
      style={{ zIndex: 99999999, position: 'absolute' }}
    >
      <ModalContainer isOpen={isOpen} disableOverlayClose closeButton={false}>
        <div data-testid="DeleteFormResultModal--content">
          <div className="sui-flex sui-mb-4">
            <h2
              data-testid="DeleteFormResultModal--heading"
              className="sui-heading-md"
            >
              {headerText}
            </h2>
          </div>

          <div
            data-testid="DeleteFormResultModal--body"
            className={`sui-body sui-flex ${
              displayWarning ? 'sui-mb-2' : 'sui-mb-4'
            }`}
          >
            {bodyText}
          </div>

          {displayWarning && (
            <div className="sui-body sui-flex sui-mb-4 sui-bg-gray-40/10 sui-p-1">
              <Icon name="warning" className="sui-text-red-40" />
              <p
                data-testid="DeleteFormResultModal--warning"
                className="sui-ml-1"
              >
                {warningText}
              </p>
            </div>
          )}

          <div className="sui-flex sui-justify-end">
            <LabelButton
              data-testid="DeleteFormResultModal--cancel"
              onClick={onClose}
              variantType="tertiary"
            >
              Cancel
            </LabelButton>

            <LabelButton
              data-testid="DeleteFormResultModal--confirm"
              disabled={!inProcessRegistrations.length}
              onClick={onSubmit}
              className="sui-ml-1"
              variantType="primary"
            >
              Confirm
            </LabelButton>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default DeleteFormResultModal;
